import { Row, Col, Typography } from 'antd'
import { Link } from 'react-router-dom'
import ForgetPasswordForm from 'container/ForgetPasswordForm'

const { Title } = Typography

const Forgotpassword = () => {
	return (
		<Row justify='center' align='middle' className='full-height'>
			<Col xs={20} md={10} xl={6}>
				<Row justify='center' align='middle'>
					<Title>Reset Password</Title>
				</Row>
				<ForgetPasswordForm />
				<Row justify='center' align='middle'>
					<Link to='/login'>Back To Login</Link>
				</Row>
			</Col>
		</Row>
	)
}

export default Forgotpassword
